export interface NewInquiryFormValues {
  title?: string;
  category_id?: string;
}

/** Build the server-owned thread payload; an omitted title lets BizAI create it. */
export const createThreadRequest = (
  values: NewInquiryFormValues,
  companyId: string | number,
) => {
  const title = values.title?.trim();
  return {
    ...(title ? { title } : {}),
    category_id: values.category_id,
    company_id: companyId,
  };
};
